export const convertFiltersToV5Format = (v6FilterArray) => {
  if (!Array.isArray(v6FilterArray)) return [];

  return v6FilterArray.map(({ field, operator, ...rest }) => ({
    columnField: field,
    operatorValue: operator,
    ...rest,
  }));
};
